import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";

import APIClient from "web_modules/APIClient";
import { AppShape, HurdleShape } from "@eave/shared/types/api";

import FlagList from "./FlagList";
import HurdleView from "underwriter_dashboard/shared/HurdleView";

require("../../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/flags.scss");

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class FlagsHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      flagsByHurdle: [],
    };
  }

  componentDidMount() {
    this.getFlags();
  }

  getFlags() {
    const { app } = this.props;

    APIClient.get(`/flags/${app.id}`, resp => {
      const flags = resp.flags || [];
      const flagsByHurdle = _.groupBy(flags, (flag: any) => flag.hurdle_type);
      this.setState({
        flagsByHurdle,
      });
    });
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        {Object.keys(this.state.flagsByHurdle).map((hurdleName, index) => (
          <section className="flag-group" key={index}>
            <h3 className="flag-group__subheading">{hurdleName}</h3>
            <FlagList
              key={index}
              flags={this.state.flagsByHurdle[hurdleName]}
              app_id={app.id}
              hurdle_name={hurdle.name}
              onUpdate={this.getFlags.bind(this)}
            />
          </section>
        ))}
      </HurdleView>
    );
  }
}

export default connect()(FlagsHurdleEditor);
